import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69d00f2534b9ae00143ad151/cibilanalyser/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69d00f2534b9ae00143ad151/cibilanalyser/src/components/ui/BrowserCompatibilityWarning.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69d00f2534b9ae00143ad151/cibilanalyser/src/components/ui/SuppressRateLimitError.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LicenseProvider"] */ "/home/ubuntu/download_production/69d00f2534b9ae00143ad151/cibilanalyser/src/contexts/LicenseContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d00f2534b9ae00143ad151/cibilanalyser/src/styles/tailwind.css");
